import {
  Briefcase,
  Clock,
  Database,
  FileText,
  FolderInput,
  Mail,
  Microscope,
  Server,
  Settings,
  Shield,
} from 'lucide-react'
import type { Tab } from './case-detail-page.helpers'

export const TABS: Tab[] = [
  { id: 'overview', icon: <Briefcase className="h-4 w-4" /> },
  { id: 'scope', icon: <FileText className="h-4 w-4" /> },
  { id: 'settings', icon: <Settings className="h-4 w-4" /> },
  { id: 'infrastructure', icon: <Server className="h-4 w-4" /> },
  { id: 'collections', icon: <FolderInput className="h-4 w-4" /> },
  { id: 'processing', icon: <Database className="h-4 w-4" /> },
  { id: 'analysis', icon: <Microscope className="h-4 w-4" /> },
  { id: 'custody', icon: <Shield className="h-4 w-4" /> },
  { id: 'history', icon: <Clock className="h-4 w-4" /> },
  { id: 'communications', icon: <Mail className="h-4 w-4" /> },
]
